import React, { useEffect, useState } from "react";
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import galleryData from "../data/galleryData";

function Projects() {
  const itemsToShow = 6;
  const batchSize = 6;
  const [visibleCount, setVisibleCount] = useState(itemsToShow);
  const [allImages, setAllImages] = useState([]);
  useEffect(() => {
    setAllImages(galleryData);
  }, []);

  useEffect(() => {
    if (visibleCount > 0) {
      Fancybox.unbind("[data-fancybox='gallery']");
      Fancybox.bind("[data-fancybox='gallery']", {
        Thumbs: false,
      });
    }
    return () => Fancybox.destroy();
  }, [visibleCount]);

  const handleToggle = () => {
    if (visibleCount >= allImages.length) {
      setVisibleCount(itemsToShow);
      window.scrollTo({
        top: document.querySelector(".home-project-sec").offsetTop - 100,
        behavior: "smooth",
      });
    } else {
      setVisibleCount((prev) => prev + batchSize);
    }
  };

  const visibleImages = allImages.slice(0, visibleCount);
  const showButton = allImages.length > itemsToShow;
  const showAll = visibleCount >= allImages.length;

  return (
    <>
      <section className="inner-banner-sec Gallery_page_banner">
        <div className="container-fluid add-padding-2">
          <div className="inner-bg-img">
            <div className="row">
              <div className="col-lg-12 align-self-center">
                <div className="banner_text wow fadeInLeft" data-wow-duration="2s">
                  <h1>
                    <span>Gallery</span>
                  </h1>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="prodject-sec home-project-sec">
        <div className="container-fluid">
          <div className="row justify-content-center">
            <div className="col-12">
              <div className="section-heading">
                <h2>Gallery</h2>
              </div>
            </div>

            <div className="col-12">
              <div className="row">
                {visibleImages.map((p, index) => (
                  <div className="col-md-4" key={index}>
                    <div className="project-img-box">
                      <a
                        href={p.img}
                        data-fancybox="gallery"
                        data-caption={`Gallery Image ${index + 1}`}
                        style={{ width: "100%" }}
                      >
                        <img src={p.img} alt="" className="img-fluid" />
                      </a>
                    </div>
                  </div>
                ))}

                {showButton && (
                  <div className="view_gallery_btn text-center mb-5">
                    <button
                      type="button"
                      className="view-more-btn theme-btn-1"
                      onClick={handleToggle}
                    >
                      {showAll ? "View Less" : "View More"}
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Projects;
